/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2020 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
import React, { Component } from 'react';
import { Route } from 'react-router-dom';
export const withRoute = (WrappedComponent, extension = 'html') => {
    return class CompositeRoute extends Component {
        render() {
            const routePath = this.props.cqPath;
            if (!routePath) {
                return React.createElement(WrappedComponent, { ...this.props });
            }
            // Context path + route path + extension
            return (React.createElement(Route, { key: routePath, exact: true, path: `(.*)${routePath}(.${extension})?`, render: (routeProps) => (React.createElement(WrappedComponent, { ...this.props, ...routeProps })) }));
        }
    };
};
